module.exports = __webpack_public_path__ + "static/media/auth-logo.f07041c4.png";